import { render, staticRenderFns } from "./MoveTextLink.vue?vue&type=template&id=02d5de5d&scoped=true&"
import script from "./MoveTextLink.vue?vue&type=script&lang=js&"
export * from "./MoveTextLink.vue?vue&type=script&lang=js&"
import style0 from "./MoveTextLink.vue?vue&type=style&index=0&id=02d5de5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d5de5d",
  null
  
)

export default component.exports